<template>
  <div>

    <md-dialog :md-active.sync="showDialog">
      <div>         
        <md-button class="md-icon-button icon1" @click="cancel">
          <md-icon >cancel</md-icon>
        </md-button> 
        <br/>
        <md-dialog-title>{{ in_title }}</md-dialog-title>
        <br/>
       </div>

      <md-dialog-content  style="height:600px;width:1200px">
          <div v-if="isFromWT">
            <md-field class="wtWidth">
              <label>Scan Weight Ticket</label>
              <md-input v-model="scanWt"></md-input>
            </md-field>  
          </div>  
          <table v-if="showTable">
            <tr>
              <td>
                <label>Pos X</label>
              </td>  
              <td>
                <label>Pos Y</label>
              </td>  
              <td>
                <label>Page X</label>
              </td>  
              <td>
                <label>Page Y</label>
              </td>  
              <td>
                <label>OffsetLeft</label>
              </td>  
              <td>
                <label>OffsetTop</label>
              </td>  
            </tr>  
            <tr>
              <td>
                <md-field>
                   <md-input v-model="posX_org"/>
                </md-field>   
              </td>  
              <td>
                <md-field>
                   <md-input v-model="posY_org"/>
                </md-field>   
              </td>  
              <td>
                <md-field>
                   <md-input v-model="pageX_org"/>
                </md-field>   
              </td>  
              <td>
                <md-field>
                   <md-input v-model="pageY_org"/>
                </md-field>   
              </td>  
              <td>
                <md-field>
                    <md-input v-model="img_offsetLeft"/>
                </md-field>    
              </td>  
              <td>
                <md-field>
                    <md-input v-model="img_offsetTop"/>
                </md-field>    
              </td>  
            </tr>
            <tr>
              <td>
                <label>Pos X act</label>
              </td>  
              <td>
                <label>Pos Y act</label>
              </td>  
              <td>
                <label>Width</label>
              </td>  
              <td>
                <label>Height</label>
              </td>  
            </tr>    
            <tr>
              <td>
                <md-field>
                    <md-input v-model="posX_act"/>
                </md-field>     
              </td>  
              <td>
                <md-field>
                    <md-input v-model="posY_act"/>
                </md-field>    
              </td>  
              <td>
                <md-field>
                    <md-input v-model="img_Width"/>
                </md-field>     
              </td>  
              <td>
                <md-field>
                    <md-input v-model="img_Height"/>
                </md-field>    
              </td>  
            </tr>  
          </table>  

        <div class="ccic-photos-container">
          <div :key="getPhotoWrapperKey(w)" v-for="w in getPhotoWrapperList">
            <!--<ccic-photo :photo="w.photo" :photoMeta="w.meta" :savePhotoButton = savePhotoButton :do-photo-upload="doPhotoUpload" />-->
            <div id="img_container">
                <img :src="urlToShow" id="sourceImg" @mousemove="zoomIn" @mouseout="zoomOut" width="640" height="480">
            </div>
            <div id="preview" @mousemove="zoomIn"></div>
            <div style="height:10px"></div>
          </div>
        </div>
      </md-dialog-content>
    </md-dialog>
  </div>

</template>
<style scoped>
  .ccic-photos-container {
    min-width: 800px;
  }

  .md-dialog-content {
    padding: 8px;
  }

  .icon1{
    /* cursor: pointer; */
    float: right;
    margin: 5px;
  }

  #preview {
    margin-top: -400px;
    margin-left: 790px;
    border: 1px solid black;
    width: 250px;
    height: 300px;
    background-repeat: no-repeat;
    /*margin-left: auto;*/
    margin-right: auto;
    object-fit: none;
  }

  #preview.large {
    height: 300px;
  }

  #preview.small {
    height: 100px;
  }

  #img_container {
    text-align: center;
  }

  #img_container img {
    margin: 10px;
    display: block;
    border: 2px solid #6A6462;
    object-fit: fill;
  }

  #img_container img:hover {
    cursor: zoom-in;
    border: 0;
    -moz-box-shadow: 2px 2px 7px 2px rgba(130,130,130,1), -1px -1px 7px 2px rgba(130,130,130,1);
    -webkit-box-shadow: 2px 2px 7px 2px rgba(130,130,130,7), -1px -1px 7px 2px rgba(130,130,130,1);
    box-shadow: 2px 2px 7px 2px rgba(130,130,130,7), -2px -2px 7px 2px rgba(130,130,130,1);
  }

  @media screen and (max-width: 640px) {
    #img_container img {
      display: inline-block;
    }
  }
  
  .position input{
    width: 50px;
    margin-left: 5px;
  }

  .wtWidth {
    width: 300px;
  }
  
</style>
<script>
  import { mapGetters } from 'vuex';
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';
  import CcicPhoto from "./CcicPhoto.vue";

  export default {
    props: {
      onDataRefresh: Function,
      onScan: Function,
      title: null,
    },
    components: { CcicPhoto },
    data: () => ({
      showDialog: false,
      photoZipFileName: '',
      parentSeqNo: '',
      parentType: '',
      stageNo: '',
      photos: [],
      hasPhotoChanged: false,
      photoMeta: [],
      getPhotoRequest: null,
      urlToSave:null,
      urlToShow:null,
      savePhotoButton: false,
      posX_org: 0,
      posY_org: 0,
      pageX_org: 0,
      pageY_org: 0,
      img_offsetLeft: 0,
      img_offsetTop: 0,
      posX_act: 0,
      posY_act: 0,
      img_Width: 0,
      img_Height: 0,
      showTable: false,
      in_title: null,
      scanWt: null,
      isFromWT: false,
    }),
    computed: {
      ...mapGetters([
        'getUserProfile',
      ]),
      getPhotoWrapperList() {
        return this.photoMeta.map(meta => {
          const photo = this.getPhotoForKey(meta.key);
          
          if (photo) {
            //console.log("photo photoUrl--: " + photo.photoUrl);
            photo.photoUrl = `${photo.photoUrl}?t=${moment(photo.updatedAt)
              .unix()}`;
            //console.log("photo photoUrl: " + photo.photoUrl);
          }
          return {
            meta,
            photo,
          };
        });
      },
    },
    watch: {
      showDialog(val) {
        if (val === false) {
          //console.log(`1`);
          if (this.hasPhotoChanged) {
            this.onDataRefresh(this.urlToSave, this.parentSeqNo);
          }
          //console.log(`2`);
          this.photoMeta = [];
          this.photos = [];
          this.hasPhotoChanged = false;
          this.savePhotoButton = false;
          this.$store.commit('clearApiError');
        }
      },
    },
    methods: {
      async openDialog(photoZipFileName, parentSeqNo, parentType, photoMeta, getPhotoRequest, savePhotoButton, scanWT) {
        this.savePhotoButton = savePhotoButton;
        this.photoZipFileName = photoZipFileName;
        this.parentSeqNo = parentSeqNo;
        this.parentType = parentType;
        this.photoMeta = photoMeta;
        this.showDialog = true;
        this.getPhotoRequest = getPhotoRequest;
        this.hasPhotoChanged = true;
        this.urlToSave = null;
        console.log("wt: " + scanWT);
        if (scanWT != null)
        {
           this.scanWt = scanWT;
           this.isFromWT = true;
        }   
        else
        {
           this.isFromWT = false;
        }

        console.log("getphotorequest: " + JSON.stringify(getPhotoRequest));
        if (this.title != null)
        {
           this.in_title = this.title;
        }
        else
           this.in_title = "BOL Photos (Zoom)"
        
        this.photos = await this.getPhoto();
        var tstamp = Math.round(+new Date()/1000);
        if (this.photos.photo.length != 0)
        {
            this.urlToSave = this.photos.photo[0].photoUrl;
            this.urlToShow = this.urlToSave + "?" + tstamp;
            //console.log("urlToShow: " + this.urlToShow);
        }
        
        // if (this.photoMeta[0])
        //    console.log("photoMeta fileName: " + this.photoMeta[0].fileName);
        // if (this.photoMeta[1])
        //    console.log("photoMeta1 fileName: " + this.photoMeta[1].fileName);
        // if (this.urlToSave)   
        //    console.log("urlToSave: " + this.urlToSave);

        
      },
      getPhotoForKey(key) {
        console.log("key: " + key);
        return _(this.photos.photo)
          .find(it => it.photoKey === key);
      },
      async doPhotoUpload(request) {
        request.parentSeqNo = this.parentSeqNo;
        request.parentType = this.parentType;
        request.image.folder = `INBOUND/${this.parentSeqNo}`;
        //await api.post('/api/w/ccic/photo/save', request);
        await newAPIPost('/api/w/ccic/photo/save', request);
        this.photos = await this.getPhoto();
        if (this.photos.photo.length != 0)
        {
            this.urlToSave = this.photos.photo[0].photoUrl;
        }

        console.log(this.urlToSave);
        
        
      },
      getPhotoWrapperKey(w) {
        if (w.photo) {
          return `${w.meta.key}-${moment(w.photo.updatedAt)
            .format()}`;
        }
        return w.meta.key;
      },
     getPhoto() {
        //return  api.post('/api/w/gst/photo/get', this.getPhotoRequest)
        return  newAPIPost('/api/w/gst/photo/get', this.getPhotoRequest)
        
      },
      zoomIn: function (event) {
        var pre = document.getElementById("preview");
        if (pre) {
           pre.style.visibility = "visible";
           //if ($('#imgSource').is(':hover')) {
           //console.log($('#imgSource:hover').length);  
           if ($('#imgSource:hover').length === 0) {
              //console.log("hover");
              //console.log("url image: " + this.urlToSave);
              var url = "url(" + this.urlToShow + ")";
              //url = url.replace("https","http");
              //console.log(url);
              pre.style.backgroundImage = url;
           }
           //var posX = event.offsetX;
           var posX_org = event.offsetX;
           var posY_org = event.offsetY;
           var pageX_org = event.pageX;
           var pageY_org = event.pageY;
           var img = document.getElementById("sourceImg");
           var img_offsetLeft = img.offsetLeft;
           var img_offsetTop = img.offsetTop;
           //var posX = posX_org ? (posX_org) : pageX_org - img_offsetLeft;
           //var posY = posY_org ? (posY_org) : pageY_org - img_offsetTop;
           var posX = posX_org;
           var posY = posY_org;
           this.posX_org = posX_org;
           this.posY_org = posY_org;
           this.pageX_org = pageX_org;
           this.pageY_org = pageY_org;
           this.img_offsetLeft = img_offsetLeft;
           this.img_offsetTop = img_offsetTop;
           this.img_Width = img.width;
           this.img_Height = img.height;
           //var formularX = (pageX_org - posX)/pageX_org*100*-1;
           //var formularY = (pageY_org - posY)/pageY_org*100*-1;
           var formularX = (posX*1.5/10);
           var formularY = (posY*1.2/10);
           if (img.height <= 480) {
              //console.log("height is less than or equal to 480");
              formularY = (posY*1.95/10);
           }   
           else
           {
              pre.style.marginTop = "-750px";
           }
           this.posX_act = formularX;
           this.posY_act = formularY;
           pre.style.backgroundPosition= formularX + "% " + formularY + "%";
           //console.log(pre.style.backgroundPosition);
           pre.style.transform = "scale(2)"; //1.5
        }
      },
      zoomOut: function() {
        var pre = document.getElementById("preview");
        if (pre) {
           pre.style.visibility = "hidden";
        }
      },

      cancel() {
        if (this.scanWt != null)
        {
            this.onScan(this.scanWt);
        }
        this.showDialog = false;
      },

    },
  };
</script>
